import React from 'react';
import Navigation from '@/components/Navigation';

const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-t from-transparent to-blue-50/70 backdrop-blur-md">
      <div className="container mx-auto px-2 sm:px-4 md:px-6">
        <div className="flex items-center justify-center h-12 sm:h-14">
          <Navigation />
        </div>
      </div>
    </header>
  );
};

export default Header;
